import flatpckr from 'flatpickr';
import { Japanese } from "flatpickr/dist/l10n/ja.js" //日本語用モジュール

jQuery(function($) {
    let minDate = new Date();
    // 翌日にするなら▼
    // minDate = minDate.setDate(minDate.getDate() + 1);

    // 日付
    $('.flatpickr').flatpickr({
        locale : Japanese,
        dateFormat : 'Y-m-d',
        // dateFormat : 'Y.m.d(D)',
        minDate     : minDate,
        disableMobile: 'true',
    });

    // 時間
    $('.flatpickr-24hour-0900').flatpickr({
        locale : Japanese,
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        defaultDate: "09:00",
        disableMobile: 'true',
    });
    $('.flatpickr-24hour-1800').flatpickr({
        locale : Japanese,
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        defaultDate: "18:00",
        disableMobile: 'true',
    });
});
